<template>
  <div>
    <div class="mb-2 d-flex">

    </div>
    <div
      id="container"
      style="width: 100%; height: 84vh"
    ></div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';

export default {
  name: 'dashboard',
  data() {
    return {
      reports: [],
      userInfor: null,
      reportRender: null,
    };
  },
  components: {},
  created() {},
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: 'Dashboard' }]);
  },
  methods: {},
};
</script>


